export type AbortablePromise<T> = Promise<T> & {
	abort: () => void;
	isAborted: () => boolean;
};

export function isAbortable<T>(promise: Promise<T>): promise is AbortablePromise<T> {
	return (
		typeof (promise as AbortablePromise<T>).abort === 'function' &&
		typeof (promise as AbortablePromise<T>).isAborted === 'function'
	);
}

/**
 * Adds abortable support to a promise.
 * Future improvement is to add support for AbortController signal.
 * @param promise The promise to add abortable support to
 * @returns An abortable promise
 */
export function makeAbortable<T>(promise: Promise<T>): AbortablePromise<T> {
	let isAborted = false;

	const wrappedPromise = new Promise<T>((resolve, reject) => {
		promise
			.then((value) => {
				if (!isAborted) {
					resolve(value);
				}
			})
			.catch((error) => {
				if (!isAborted) {
					reject(error);
				}
			});
	}) as AbortablePromise<T>;

	wrappedPromise.abort = () => {
		isAborted = true;
	};

	wrappedPromise.isAborted = () => isAborted;

	return wrappedPromise;
}
